import React from 'react'
import Route from 'react-router/lib/Route'
import IndexRoute from 'react-router/lib/IndexRoute'

import App from 'containers/App'
import Login from 'containers/Auth/Login'
import Logout from 'containers/Auth/Logout'
import ForgotPassword from 'containers/Auth/ForgotPassword'
import ResetPassword from 'containers/Auth/ResetPassword'

import Admin from 'containers/Admin'
import Dashboard from 'containers/Dashboard'
import Account from 'containers/Account'

import Enrolment from 'containers/Enrolment'
import EnrolmentDefault from 'containers/Enrolment/default'
import Apply from 'containers/Enrolment/Apply'
import Modify from 'containers/Enrolment/Modify'
import AddWithdraw from 'containers/Enrolment/AddWithdraw'

import COR from 'containers/COR'
import COR2 from 'containers/COR2'
import Billing from 'containers/Billing'
import Grades from 'containers/Grades'
import Curriculum from 'containers/Curriculum'
import Ledger from 'containers/Ledger'

import auth from 'containers/Admin/authentication'

export default function createRoutes(store) {
  return (
    <Route component={App}>
      <Route path="login" component={Login} />
      <Route path="logout" component={Logout} onEnter={Logout.onEnter(store)} />
      <Route path="forgot-password" component={ForgotPassword} />
      <Route path="reset-password" component={ResetPassword} />
      <Route path="ens/public/cor/:hashedID" component={COR2} />
      <Route path="/" component={Admin} onEnter={auth(store)}>
        <IndexRoute component={Dashboard} />
        <Route path="account" component={Account} />
        <Route path="enrolment" component={Enrolment} onEnter={Enrolment.onEnter(store)}>
          <IndexRoute component={EnrolmentDefault} />
          <Route path="apply" component={Apply} onEnter={Apply.onEnter(store)} />
          <Route path="modify" component={Modify} onEnter={Modify.onEnter(store)} />
          <Route path="add-withdraw-subjects" component={AddWithdraw} onEnter={AddWithdraw.onEnter(store)} />
        </Route>
        <Route path="cor" component={COR} onEnter={COR.onEnter(store)} />
        <Route path="curriculum" component={Curriculum} onEnter={Curriculum.onEnter(store)} />
        <Route path="grades" component={Grades} onEnter={Grades.onEnter(store)} />
        <Route path="billing" component={Billing} onEnter={Billing.onEnter(store)} />
        <Route path="ledger" component={Ledger} onEnter={Ledger.onEnter(store)} />
      </Route>
    </Route>
  )
}



// WEBPACK FOOTER //
// ./src/routes.js